import type { ReactNode } from 'react';
import type { MenuItemProps } from '@mui/material';

import { MenuItem, Typography } from '@mui/material';

// ----------------------------------------------------------------------

export const accountMenuItemSx = {
  px: 1.5,
  py: 1,
  minHeight: 40,
  borderRadius: 1,
  gap: 1.5,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
};

export const accountMenuIconSx = { color: 'grey.400', fontSize: 20 };

export type AccountMenuItemProps = Omit<MenuItemProps, 'children'> & {
  label: ReactNode;
  /** Drawn after the label. */
  icon?: ReactNode;
};

/** One row of the account menu: the label, then its icon. */
export function AccountMenuItem({ label, icon, sx, ...other }: AccountMenuItemProps) {
  return (
    <MenuItem sx={[accountMenuItemSx, ...(Array.isArray(sx) ? sx : [sx])]} {...other}>
      <Typography variant="body2" sx={{ flex: 1 }}>
        {label}
      </Typography>
      {icon}
    </MenuItem>
  );
}
